/**
 * Created by tofaelraju on 10/15/17.
 */

import React from 'react';
import {Link} from 'react-router';
import Avatar from 'material-ui/Avatar';
import MenuItem from 'material-ui/MenuItem';
import config from '../../utility/app-config';

const styles = {
  div: {
    padding: '15px 0 20px 8px',
    height: 45
  },
  icon: {
    float: 'left',
    display: 'block',
    marginRight: 10,
    boxShadow: '0px 0px 0px 5px rgba(0,0,0,0.2)'
  },
  span: {
    display: 'block',
    color: 'white',
    textShadow: '1px 1px #444'
  }
}
const UserAvatar = ({ username, photo, id })=>(
  <div style={styles.div}>
    <Avatar
      src={photo ? `${config.urls.doc_url}${photo}` : '/images/avatar.png'}
      style={styles.icon}
      size={45}
    />
  <MenuItem          
      hoverColor="transparent"
      style={styles.span}
      containerElement={<Link to={'/user/'+ id}/>}
      primaryText={username}
  />    
  </div>
);

export default UserAvatar;


// WEBPACK FOOTER //
// ./src/screens/layout/avatar.js